export default "__VITE_ASSET__Ds6TN9kk__"